export const XLSX_EXTENSION = ".xlsx";

const FALLBACK_FILE_NAME = "export";
const MAX_BASE_NAME_LENGTH = 120;
// eslint-disable-next-line no-control-regex -- stripping control characters is the point
const ILLEGAL_FILE_NAME_CHARACTERS = /[\\/:*?"<>|\x00-\x1f]/g;

// Linear trailing trim avoids the super-linear backtracking of an anchored /[.\s]+$/ (ReDoS).
function trimTrailingDotsAndWhitespace(value: string) {
    let end = value.length;
    while (end > 0) {
        const char = value[end - 1];
        if (char === undefined || (char !== "." && !/\s/.test(char))) {
            break;
        }
        end -= 1;
    }
    return value.slice(0, end);
}

function stripIllegalCharacters(value: string) {
    const normalised = value
        .replaceAll(ILLEGAL_FILE_NAME_CHARACTERS, " ")
        .replaceAll(/\s+/g, " ")
        .trim()
        .replace(/^\.+/, "");

    return trimTrailingDotsAndWhitespace(normalised).trim();
}

export function sanitiseFileName(value: string) {
    return stripIllegalCharacters(value).slice(0, MAX_BASE_NAME_LENGTH).trim() || FALLBACK_FILE_NAME;
}

export function buildExcelFileName(parts: (string | null | undefined)[]) {
    const baseName = parts
        .filter((part): part is string => Boolean(part))
        .map(stripIllegalCharacters)
        .filter(Boolean)
        .join("-");

    return `${sanitiseFileName(baseName)}${XLSX_EXTENSION}`;
}
